import type { VirtualMachineWithAssigned } from "@/modules/compute/joinAssignedQuery.ts";
import { getPrimaryStorage } from "@/modules/compute/vmEntityUtils.ts";
import { getOptionalVmPool } from "@/modules/compute/vmLogic.ts";
import { PricingModal } from "@/modules/pricing/PricingModal.tsx";
import { ReplicaPrice } from "@/modules/pricing/ReplicaPrice.tsx";
import type { VirtualMachineStorageReplica } from "@warrenio/api-spec/spec.oats.gen";

export function VmEstimatedReplicaPriceModal({
    vm,
    type,
    billingAccountId,
}: {
    vm: VirtualMachineWithAssigned;
    type: VirtualMachineStorageReplica["type"];
    billingAccountId?: number;
}) {
    const { location, priceCalc } = vm;

    const primary = getPrimaryStorage(vm);
    if (!primary) {
        return null;
    }

    const { size } = primary;
    const estimatedPrice = priceCalc.getReplicaPrice({ size, type });

    return (
        <PricingModal
            defaultLocation={location}
            defaultHostPool={getOptionalVmPool(vm)}
            billingAccountId={billingAccountId}
        >
            <ReplicaPrice type={type} price={estimatedPrice} billingAccountId={billingAccountId} />
        </PricingModal>
    );
}
